var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomePageColumnIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 164 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_733_50979)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.72671 128.852C-5.72671 128.333 -5.30693 127.913 -4.7891 127.913H11.9174C12.4353 127.913 12.855 128.333 12.855 128.852V138.437C12.855 138.955 12.4353 139.376 11.9174 139.376H-4.7891C-5.30693 139.376 -5.72671 138.955 -5.72671 138.437V128.852ZM-3.85149 129.791V137.498H10.9798V129.791H-3.85149Z",
    fill: "url(#paint0_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.953503 142.43C-0.953503 141.911 -0.53372 141.491 -0.0158911 141.491H7.14405C7.66188 141.491 8.08166 141.911 8.08166 142.43C8.08166 142.949 7.66188 143.369 7.14405 143.369H-0.0158911C-0.53372 143.369 -0.953503 142.949 -0.953503 142.43Z",
    fill: "url(#paint1_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-9.56239 145.485C-10.0802 145.485 -10.5 145.905 -10.5 146.424C-10.5 146.942 -10.0802 147.363 -9.56239 147.363H-7.87464V153.892C-7.87464 154.41 -7.45486 154.831 -6.93703 154.831C-6.4192 154.831 -5.99942 154.41 -5.99942 153.892V147.363H13.1278V153.892C13.1278 154.41 13.5476 154.831 14.0654 154.831C14.5833 154.831 15.0031 154.41 15.0031 153.892V147.363H16.6907C17.2086 147.363 17.6283 146.942 17.6283 146.424C17.6283 145.905 17.2086 145.485 16.6907 145.485H-9.56239Z",
    fill: "url(#paint2_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0671 156.502C52.7932 156.502 54.1924 155.1 54.1924 153.372C54.1924 151.643 52.7932 150.242 51.0671 150.242C49.341 150.242 47.9417 151.643 47.9417 153.372C47.9417 155.1 49.341 156.502 51.0671 156.502ZM51.0671 158.38C53.8288 158.38 56.0677 156.138 56.0677 153.372C56.0677 150.606 53.8288 148.364 51.0671 148.364C48.3053 148.364 46.0665 150.606 46.0665 153.372C46.0665 156.138 48.3053 158.38 51.0671 158.38Z",
    fill: "url(#paint3_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.8208 161.51V145.234C59.8208 144.452 59.4207 143.982 58.7956 143.356C58.3162 142.856 58.1243 142.632 57.9961 142.332C57.9086 142.127 57.84 141.871 57.7786 141.466C58.226 141.395 58.568 141.007 58.568 140.539C58.568 140.02 58.1482 139.6 57.6303 139.6H44.5038C43.986 139.6 43.5662 140.02 43.5662 140.539C43.5662 141.009 43.9105 141.398 44.3602 141.467C44.299 141.87 44.2305 142.125 44.1431 142.33C44.0148 142.631 43.8225 142.857 43.344 143.356C42.7188 143.982 42.3188 144.452 42.3188 145.234V161.51C42.3188 161.76 42.3563 161.998 42.4313 162.211L43.6064 166.455C43.7184 166.881 44.1065 167.146 44.527 167.144H57.6105C58.0294 167.144 58.4174 166.879 58.5346 166.456L59.711 162.212C59.7821 161.999 59.8208 161.765 59.8208 161.51ZM44.5065 144.921C44.3339 144.921 44.194 145.061 44.194 145.234V161.51C44.194 161.683 44.3339 161.823 44.5065 161.823H57.6331C57.8057 161.823 57.9456 161.683 57.9456 161.51V145.234C57.9456 145.061 57.8057 144.921 57.6331 144.921H44.5065ZM55.8864 141.478H46.2525C46.173 142.094 46.0652 142.595 45.8782 143.043H56.2603C56.0734 142.596 55.9658 142.095 55.8864 141.478ZM45.2196 165.266H56.9184L57.3521 163.701H44.7865L45.2196 165.266Z",
    fill: "url(#paint4_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1364 147.112C85.1364 145.21 86.6756 143.669 88.5743 143.669H108.577C110.475 143.669 112.015 145.21 112.015 147.112V157.128C112.015 159.029 110.475 160.571 108.577 160.571H88.5743C86.6756 160.571 85.1364 159.029 85.1364 157.128V147.112ZM88.5743 145.547C87.7112 145.547 87.0116 146.248 87.0116 147.112V157.128C87.0116 157.992 87.7112 158.693 88.5743 158.693H108.577C109.44 158.693 110.139 157.992 110.139 157.128V147.112C110.139 146.248 109.44 145.547 108.577 145.547H88.5743Z",
    fill: "url(#paint5_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.326 152.12C107.326 153.503 106.207 154.624 104.826 154.624C103.445 154.624 102.326 153.503 102.326 152.12C102.326 150.737 103.445 149.616 104.826 149.616C106.207 149.616 107.326 150.737 107.326 152.12Z",
    fill: "url(#paint6_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8244 152.433C89.8244 151.914 90.2442 151.494 90.762 151.494H97.6378C98.1557 151.494 98.5755 151.914 98.5755 152.433C98.5755 152.951 98.1557 153.372 97.6378 153.372H90.762C90.2442 153.372 89.8244 152.951 89.8244 152.433ZM90.762 158.693C91.2799 158.693 91.6996 159.113 91.6996 159.632V162.449C91.6996 162.967 91.2799 163.388 90.762 163.388C90.2442 163.388 89.8244 162.967 89.8244 162.449V159.632C89.8244 159.113 90.2442 158.693 90.762 158.693ZM105.764 158.693C106.282 158.693 106.701 159.113 106.701 159.632V162.449C106.701 162.967 106.282 163.388 105.764 163.388C105.246 163.388 104.826 162.967 104.826 162.449V159.632C104.826 159.113 105.246 158.693 105.764 158.693Z",
    fill: "url(#paint7_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.899 136.039C150.918 130.05 141.222 130.05 135.241 136.039C134.875 136.406 134.281 136.406 133.915 136.039C133.549 135.672 133.549 135.078 133.915 134.711C140.628 127.988 151.512 127.988 158.225 134.711C158.591 135.078 158.591 135.672 158.225 136.039C157.859 136.406 157.265 136.406 156.899 136.039Z",
    fill: "url(#paint8_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.363 139.58C149.335 135.546 142.805 135.546 138.777 139.58C138.411 139.947 137.818 139.947 137.451 139.58C137.085 139.213 137.085 138.619 137.451 138.252C142.212 133.485 149.929 133.485 154.689 138.252C155.055 138.619 155.055 139.213 154.689 139.58C154.323 139.947 153.729 139.947 153.363 139.58Z",
    fill: "url(#paint9_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.827 143.121C147.752 141.043 144.388 141.043 142.313 143.121C141.947 143.488 141.354 143.488 140.987 143.121C140.621 142.755 140.621 142.16 140.987 141.793C143.795 138.982 148.346 138.982 151.153 141.793C151.519 142.16 151.519 142.755 151.153 143.121C150.787 143.488 150.193 143.488 149.827 143.121Z",
    fill: "url(#paint10_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.323 145.632C147.323 146.323 146.763 146.884 146.073 146.884C145.382 146.884 144.822 146.323 144.822 145.632C144.822 144.94 145.382 144.38 146.073 144.38C146.763 144.38 147.323 144.94 147.323 145.632Z",
    fill: "url(#paint11_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12686 178.306C5.12686 177.787 5.54664 177.367 6.06447 177.367H31.0674C31.5853 177.367 32.005 177.787 32.005 178.306C32.005 178.824 31.5853 179.245 31.0674 179.245H6.06447C5.54664 179.245 5.12686 178.824 5.12686 178.306Z",
    fill: "url(#paint12_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.377 182.061C6.377 181.543 6.79679 181.123 7.31462 181.123H29.8173C30.3351 181.123 30.7549 181.543 30.7549 182.061C30.7549 182.58 30.3351 183 29.8173 183H7.31462C6.79679 183 6.377 182.58 6.377 182.061Z",
    fill: "url(#paint13_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8797 194.581V178.306H30.7549V194.581C30.7549 195.1 30.3351 195.52 29.8173 195.52C29.2995 195.52 28.8797 195.1 28.8797 194.581Z",
    fill: "url(#paint14_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.377 194.581V178.306H8.25223V194.581C8.25223 195.1 7.83244 195.52 7.31462 195.52C6.79679 195.52 6.377 195.1 6.377 194.581Z",
    fill: "url(#paint15_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.071 198.756C61.071 198.238 61.4908 197.817 62.0086 197.817H70.1346C70.6524 197.817 71.0722 198.238 71.0722 198.756C71.0722 199.275 70.6524 199.695 70.1346 199.695H62.0086C61.4908 199.695 61.071 199.275 61.071 198.756Z",
    fill: "url(#paint16_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0086 197.817C61.4908 197.817 61.071 198.238 61.071 198.756C61.071 199.275 61.4908 199.695 62.0086 199.695H70.1346C70.6524 199.695 71.0722 199.275 71.0722 198.756C71.0722 198.238 70.6524 197.817 70.1346 197.817H62.0086Z",
    fill: "url(#paint17_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.1182 184.985C64.1952 184.985 62.6164 185.543 61.3526 186.512C60.1014 187.471 59.2109 188.791 58.5782 190.243C57.3217 193.125 57.008 196.696 57.008 199.582C57.008 200.965 57.5183 202.083 58.3777 202.845C59.2201 203.593 60.3252 203.935 61.4282 203.935H62.2034L59.3759 210.542C59.1719 211.019 59.3924 211.571 59.8684 211.775C60.3443 211.98 60.8955 211.759 61.0995 211.282L62.3075 208.459H69.8357L71.0437 211.282C71.2477 211.759 71.7989 211.98 72.2748 211.775C72.7508 211.571 72.9713 211.019 72.7673 210.542L69.9398 203.935H70.715C71.818 203.935 72.9231 203.593 73.7656 202.845C74.6248 202.083 75.1352 200.965 75.1352 199.582C75.1352 196.702 74.8458 193.131 73.6143 190.249C72.9939 188.797 72.1156 187.475 70.8721 186.514C69.6156 185.543 68.0413 184.985 66.1182 184.985ZM60.2968 190.994C59.1966 193.518 58.8832 196.777 58.8832 199.582C58.8832 200.475 59.1975 201.064 59.6211 201.44C60.0616 201.83 60.6978 202.057 61.4282 202.057H70.715C71.4454 202.057 72.0816 201.83 72.5221 201.44C72.9457 201.064 73.2599 200.475 73.2599 199.582C73.2599 196.771 72.9688 193.512 71.8903 190.988C71.3556 189.737 70.6465 188.712 69.7266 188.001C68.8195 187.3 67.6543 186.863 66.1182 186.863C64.582 186.863 63.4095 187.3 62.4923 188.003C61.5626 188.716 60.8423 189.743 60.2968 190.994ZM67.8996 203.935H64.2436L63.1112 206.581H69.032L67.8996 203.935Z",
    fill: "url(#paint18_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.889 193.436C103.889 192.053 105.008 190.932 106.389 190.932H118.89C120.271 190.932 121.391 192.053 121.391 193.436V193.748H122.641C124.54 193.748 126.079 195.29 126.079 197.191V199.695C126.079 201.597 124.54 203.138 122.641 203.138H121.391V204.703C121.391 208.161 118.592 210.963 115.14 210.963H110.139C106.687 210.963 103.889 208.161 103.889 204.703V193.436ZM118.89 192.81H106.389C106.044 192.81 105.764 193.09 105.764 193.436V204.703C105.764 207.123 107.723 209.085 110.139 209.085H115.14C117.556 209.085 119.515 207.123 119.515 204.703V193.436C119.515 193.09 119.236 192.81 118.89 192.81ZM122.641 195.626H121.391V201.26H122.641C123.504 201.26 124.203 200.56 124.203 199.695V197.191C124.203 196.327 123.504 195.626 122.641 195.626Z",
    fill: "url(#paint19_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.889 189.68C108.371 189.68 107.952 189.259 107.952 188.741V187.489C107.952 186.97 108.371 186.55 108.889 186.55C109.407 186.55 109.827 186.97 109.827 187.489V188.741C109.827 189.259 109.407 189.68 108.889 189.68Z",
    fill: "url(#paint20_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.64 189.68C112.122 189.68 111.702 189.259 111.702 188.741V185.611C111.702 185.092 112.122 184.672 112.64 184.672C113.157 184.672 113.577 185.092 113.577 185.611V188.741C113.577 189.259 113.157 189.68 112.64 189.68Z",
    fill: "url(#paint21_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.39 189.68C115.872 189.68 115.452 189.259 115.452 188.741V187.489C115.452 186.97 115.872 186.55 116.39 186.55C116.908 186.55 117.328 186.97 117.328 187.489V188.741C117.328 189.259 116.908 189.68 116.39 189.68Z",
    fill: "url(#paint22_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.622 178.609C147.622 176.708 149.161 175.166 151.06 175.166H171.062C172.961 175.166 174.5 176.708 174.5 178.609V191.129C174.5 193.031 172.961 194.572 171.062 194.572H151.06C149.161 194.572 147.622 193.031 147.622 191.129V178.609ZM151.06 177.044C150.197 177.044 149.497 177.745 149.497 178.609V191.129C149.497 191.993 150.197 192.694 151.06 192.694H171.062C171.925 192.694 172.625 191.993 172.625 191.129V178.609C172.625 177.745 171.925 177.044 171.062 177.044H151.06Z",
    fill: "url(#paint23_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.415 182.043C167.781 182.409 167.781 183.004 167.415 183.371L162.869 187.923C162.693 188.099 162.454 188.198 162.206 188.198C161.957 188.198 161.719 188.099 161.543 187.923L158.796 185.173L156.05 187.923C155.684 188.29 155.09 188.29 154.724 187.923C154.358 187.557 154.358 186.962 154.724 186.595L158.133 183.181C158.309 183.005 158.548 182.906 158.796 182.906C159.045 182.906 159.283 183.005 159.459 183.181L162.206 185.931L166.089 182.043C166.455 181.676 167.049 181.676 167.415 182.043Z",
    fill: "url(#paint24_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.922 193.377C157.398 193.581 157.619 194.133 157.415 194.61L155.199 199.788C154.995 200.265 154.443 200.486 153.967 200.282C153.491 200.077 153.271 199.525 153.475 199.049L155.691 193.87C155.895 193.393 156.446 193.173 156.922 193.377Z",
    fill: "url(#paint25_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M165.2 193.377C164.724 193.581 164.503 194.133 164.707 194.61L166.923 199.788C167.127 200.265 167.678 200.486 168.154 200.282C168.63 200.077 168.851 199.525 168.647 199.049L166.431 193.87C166.227 193.393 165.676 193.173 165.2 193.377Z",
    fill: "url(#paint26_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.748 172.975C161.266 172.975 161.686 173.396 161.686 173.914V175.792C161.686 176.311 161.266 176.731 160.748 176.731C160.231 176.731 159.811 176.311 159.811 175.792V173.914C159.811 173.396 160.231 172.975 160.748 172.975Z",
    fill: "url(#paint27_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-7.86168 220.56H15.2645C15.5396 220.565 15.8099 220.627 16.0592 220.741C16.3083 220.855 16.5301 221.019 16.7134 221.22C16.8966 221.421 17.038 221.655 17.1318 221.908C17.2243 222.158 17.2693 222.423 17.2653 222.689V236.693L17.2582 236.75C17.1946 237.267 16.9622 237.754 16.5894 238.123C16.2156 238.494 15.7231 238.723 15.1936 238.759L15.1617 238.761H-7.87662C-8.1518 238.757 -8.42202 238.695 -8.67131 238.581C-8.92047 238.466 -9.14229 238.303 -9.32556 238.102C-9.50873 237.901 -9.65014 237.667 -9.74393 237.413C-9.83644 237.163 -9.88145 236.898 -9.87743 236.632V222.689C-9.88145 222.423 -9.83644 222.158 -9.74393 221.908C-9.65016 221.655 -9.50877 221.421 -9.32556 221.22C-9.14229 221.019 -8.92047 220.855 -8.67131 220.741C-8.42202 220.627 -8.1518 220.565 -7.87661 220.56L-7.86168 220.56ZM-7.85028 222.438C-7.8628 222.439 -7.87633 222.442 -7.89054 222.448C-7.90625 222.456 -7.92394 222.468 -7.94107 222.486C-7.95827 222.505 -7.97421 222.53 -7.98563 222.561C-7.99708 222.592 -8.00311 222.627 -8.00239 222.662L-8.0022 222.672V236.65L-8.00239 236.659C-8.00311 236.695 -7.99707 236.729 -7.98563 236.76C-7.97423 236.791 -7.95831 236.816 -7.94107 236.835C-7.92394 236.854 -7.90625 236.866 -7.89054 236.873C-7.87633 236.88 -7.8628 236.883 -7.85028 236.883H15.0866C15.1487 236.874 15.2137 236.845 15.2705 236.788C15.3264 236.733 15.3706 236.655 15.3901 236.563V222.672L15.3902 222.662C15.391 222.627 15.3849 222.592 15.3735 222.561C15.3621 222.53 15.3461 222.505 15.3289 222.486C15.3118 222.468 15.2941 222.456 15.2784 222.448C15.2642 222.442 15.2506 222.439 15.2381 222.438H-7.85028Z",
    fill: "url(#paint28_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.15734 241.531C-2.15734 241.012 -1.73755 240.592 -1.21972 240.592H8.60328C9.12111 240.592 9.54089 241.012 9.54089 241.531C9.54089 242.05 9.12111 242.47 8.60328 242.47H-1.21972C-1.73755 242.47 -2.15734 242.05 -2.15734 241.531Z",
    fill: "url(#paint29_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7812 229.705C45.0972 229.389 45.5924 229.34 45.9642 229.588L47.3194 230.493L48.6745 229.588C48.9894 229.378 49.3997 229.378 49.7147 229.588L51.0698 230.493L52.4249 229.588C52.7399 229.378 53.1502 229.378 53.4651 229.588L54.8203 230.493L56.1754 229.588C56.5473 229.34 57.0424 229.389 57.3585 229.705L58.1308 230.479L60.0266 229.529C60.3658 229.359 60.7738 229.411 61.0602 229.66C61.3467 229.909 61.4553 230.306 61.3354 230.666L60.1487 234.232C60.7585 240.367 61.1217 245.394 60.1536 252.813L61.3354 256.364C61.4553 256.724 61.3467 257.121 61.0602 257.37C60.7738 257.619 60.3658 257.671 60.0266 257.501L58.1308 256.551L57.3585 257.325C57.0424 257.641 56.5473 257.691 56.1754 257.442L54.8203 256.537L53.4651 257.442C53.1502 257.653 52.7399 257.653 52.4249 257.442L51.0698 256.537L49.7147 257.442C49.3997 257.653 48.9894 257.653 48.6745 257.442L47.3194 256.537L45.9642 257.442C45.6493 257.653 45.239 257.653 44.9241 257.442L43.5689 256.537L42.2138 257.442C41.8805 257.665 41.4429 257.651 41.1246 257.407C40.8063 257.164 40.6775 256.745 40.8042 256.364L41.9935 252.791C41.9633 252.429 41.9337 252.077 41.9048 251.734C41.3496 245.127 41.0637 241.724 41.9872 234.22L40.8042 230.666C40.6843 230.306 40.7929 229.909 41.0794 229.66C41.3659 229.411 41.7738 229.359 42.113 229.529L44.0089 230.479L44.7812 229.705ZM43.299 232.223L43.8333 233.828C43.8776 233.961 43.8916 234.102 43.8742 234.242C42.9435 241.698 43.2163 244.945 43.7737 251.579C43.8076 251.982 43.8425 252.397 43.8782 252.827C43.8888 252.954 43.8735 253.081 43.8333 253.202L43.4066 254.484C43.6394 254.443 43.8844 254.491 44.089 254.628L45.4441 255.532L46.7993 254.628C47.1142 254.417 47.5245 254.417 47.8395 254.628L49.1946 255.532L50.5497 254.628C50.8647 254.417 51.275 254.417 51.5899 254.628L52.945 255.532L54.3002 254.628C54.6151 254.417 55.0254 254.417 55.3403 254.628L56.576 255.453L57.2826 254.745C57.568 254.459 58.004 254.388 58.3649 254.569L58.8406 254.807L58.3063 253.202C58.2612 253.066 58.2475 252.922 58.2664 252.781C59.2523 245.376 58.8853 240.452 58.2628 234.219C58.2497 234.087 58.2645 233.954 58.3063 233.828L58.8406 232.223L58.3649 232.461C58.004 232.642 57.568 232.571 57.2826 232.285L56.576 231.577L55.3403 232.402C55.0254 232.613 54.6151 232.613 54.3002 232.402L52.945 231.498L51.5899 232.402C51.275 232.613 50.8647 232.613 50.5497 232.402L49.1946 231.498L47.8395 232.402C47.5245 232.613 47.1142 232.613 46.7993 232.402L45.5636 231.577L44.857 232.285C44.5716 232.571 44.1357 232.642 43.7747 232.461L43.299 232.223Z",
    fill: "url(#paint30_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1316 241.011C45.1316 240.492 45.5514 240.072 46.0692 240.072H56.0704C56.5882 240.072 57.008 240.492 57.008 241.011V246.019C57.008 246.538 56.5882 246.958 56.0704 246.958H46.0692C45.5514 246.958 45.1316 246.538 45.1316 246.019V241.011ZM47.0068 241.95V245.08H55.1328V241.95H47.0068Z",
    fill: "url(#paint31_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0062 234.125C42.0062 233.607 42.426 233.186 42.9438 233.186H59.1958C59.7136 233.186 60.1334 233.607 60.1334 234.125C60.1334 234.644 59.7136 235.064 59.1958 235.064H42.9438C42.426 235.064 42.0062 234.644 42.0062 234.125Z",
    fill: "url(#paint32_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0062 252.905C42.0062 252.386 42.426 251.966 42.9438 251.966H59.1958C59.7136 251.966 60.1334 252.386 60.1334 252.905C60.1334 253.424 59.7136 253.844 59.1958 253.844H42.9438C42.426 253.844 42.0062 253.424 42.0062 252.905Z",
    fill: "url(#paint33_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.9951 251.737C94.3304 247.11 90.5862 243.434 85.8512 242.947C85.3361 242.894 84.9614 242.433 85.0143 241.917C85.0672 241.401 85.5277 241.026 86.0428 241.078C91.643 241.654 96.0653 245.999 96.8512 251.469C96.9249 251.982 96.5692 252.458 96.0566 252.532C95.5441 252.606 95.0688 252.25 94.9951 251.737Z",
    fill: "url(#paint34_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.6131 251.948C89.1154 250.082 87.6248 248.607 85.7279 248.15C85.2244 248.029 84.9144 247.522 85.0355 247.018C85.1566 246.514 85.6629 246.203 86.1664 246.324C88.7379 246.944 90.7512 248.938 91.4248 251.463C91.5584 251.964 91.2611 252.479 90.7608 252.613C90.2606 252.747 89.7467 252.449 89.6131 251.948Z",
    fill: "url(#paint35_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9589 251.711C86.9409 252.229 86.5067 252.635 85.9892 252.616C85.4717 252.598 85.0668 252.164 85.0849 251.645C85.1029 251.127 85.5371 250.722 86.0546 250.74C86.5721 250.758 86.977 251.193 86.9589 251.711Z",
    fill: "url(#paint36_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.0227 234.388H110.149C110.424 234.392 110.694 234.454 110.944 234.569C111.193 234.683 111.415 234.847 111.598 235.048C111.781 235.248 111.922 235.483 112.016 235.736C112.109 235.986 112.154 236.251 112.15 236.517V250.521L112.143 250.578C112.079 251.095 111.847 251.582 111.474 251.951C111.1 252.322 110.608 252.551 110.078 252.587L110.046 252.589H100.949C100.431 252.589 100.011 252.169 100.011 251.65C100.011 251.132 100.431 250.711 100.949 250.711H109.971C110.033 250.702 110.098 250.673 110.155 250.616C110.211 250.561 110.255 250.483 110.274 250.391V236.5L110.275 236.49C110.275 236.454 110.269 236.42 110.258 236.389C110.246 236.358 110.231 236.333 110.213 236.314C110.196 236.295 110.178 236.283 110.163 236.276C110.149 236.27 110.135 236.267 110.122 236.266H87.0341C87.0216 236.267 87.008 236.27 86.9938 236.276C86.9781 236.283 86.9604 236.295 86.9433 236.314C86.9296 236.329 86.9166 236.348 86.9061 236.371C86.9018 236.393 86.8966 236.425 86.8921 236.46C86.8878 236.494 86.8845 236.525 86.8823 236.548L86.8822 238.457C86.8822 238.976 86.4624 239.396 85.9446 239.396C85.4267 239.396 85.0069 238.976 85.0069 238.457V236.474L85.0095 236.44L85.9446 236.509C85.0095 236.44 85.0095 236.44 85.0095 236.44L85.0097 236.437L85.0101 236.432L85.0113 236.418L85.0155 236.37C85.0192 236.332 85.0247 236.278 85.0326 236.218C85.0443 236.128 85.0729 235.919 85.1404 235.736C85.2342 235.483 85.3756 235.248 85.5588 235.048C85.7421 234.847 85.9639 234.683 86.2131 234.569C86.4623 234.454 86.7326 234.393 87.0078 234.388L87.0227 234.388Z",
    fill: "url(#paint37_linear_733_50979)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.33 231.515C137.33 228.749 139.569 226.507 142.331 226.507V221.499C142.331 219.425 144.01 217.743 146.081 217.743C148.152 217.743 149.832 219.425 149.832 221.499V221.812H153.582C154.1 221.812 154.52 222.233 154.52 222.751C154.52 223.27 154.1 223.69 153.582 223.69H149.832V226.507C152.593 226.507 154.832 228.749 154.832 231.515V240.279C154.832 243.045 152.593 245.287 149.832 245.287H142.331C139.569 245.287 137.33 243.045 137.33 240.279V231.515ZM149.832 228.385H142.331C140.605 228.385 139.205 229.786 139.205 231.515V240.279C139.205 242.008 140.605 243.409 142.331 243.409H149.832C151.558 243.409 152.957 242.008 152.957 240.279V231.515C152.957 229.786 151.558 228.385 149.832 228.385Z",
    fill: "url(#paint38_linear_733_50979)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_733_50979",
    x1: 82,
    y1: 124.2,
    x2: 82,
    y2: 309.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_733_50979"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.00001C0 3.58173 3.58172 0 8 0H156C160.418 0 164 3.58172 164 8V269.6H0V8.00001Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageColumnIcons);
export default __webpack_public_path__ + "static/media/home-page-column-icons.56ed7a831c5458e153775e00193b15af.svg";
export { ForwardRef as ReactComponent };